export default __webpack_public_path__ + "static/media/down-arrow.123d28ad.svg";